import { render, staticRenderFns } from "./frequestion.vue?vue&type=template&id=55e36768&scoped=true"
import script from "./frequestion.vue?vue&type=script&lang=js"
export * from "./frequestion.vue?vue&type=script&lang=js"
import style0 from "./frequestion.vue?vue&type=style&index=0&id=55e36768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e36768",
  null
  
)

export default component.exports